<div class="content">
    <h2 mat-dialog-title>Selecteer Nieuwe Relatie </h2>
    <mat-dialog-content>
        <form [formGroup]="RelatieFormGroup">
            <br>
            <mg-simple-form-row>
                <span mg-colspan-3>
                    <mat-form-field pd-size-max>
                        <mg-autocomplete #relatieAutocomplete placeholder="Relatie" formControlName="relatie" [displayFn]="relatieDisplayFn" [getData]="getRelatieDataSource"></mg-autocomplete>
                    </mat-form-field>
                </span>
            </mg-simple-form-row>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div style="float:left; text-align: left; width: 99%;">
            <div style="float:left; text-align: right; width: 99%;">
                <button type="button"id="savebutton" mat-button color="primary" (click)="Ok()">Ok</button>
            </div>
        </div>
    </mat-dialog-actions>
</div>

